import { useSelector } from 'react-redux';
import { isRequiredFeatureEnabled } from 'src/components/auth';
import { NavbarPermissions } from 'src/components/organisms';
import { FeatureFlag, State, User } from 'src/types';

export const useCanAccessDisclosures = (): boolean => {
  const hasDisclosuresPermission = useSelector((state: State) =>
    Boolean(
      (state.globalUsers?.currentUser as User)?.systemPermissions?.includes(
        NavbarPermissions.NAV_DISCLOSURES,
      ),
    ),
  );
  const features = useSelector(({ features }: State) => features);

  return (
    hasDisclosuresPermission &&
    isRequiredFeatureEnabled(features, FeatureFlag.CONFLICT_OF_INTEREST)
  );
};
